<template>
  <ul class="footer-menu-bottom">
    <li v-for="(item, idx) in footerBottomMenu" :key="idx" class="nav-item">
      <a :href="item.url" class="nav-link" target="_blank">
        {{ item.name }}
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { footerBottomMenu } from '~/shared/const/menu'
</script>

<style scoped lang="scss">
  .footer-menu-bottom {
    display: flex;
    align-items: center;

    @include vp-767 {
      flex-direction: column;
      align-items: unset;
      padding: 0;
    }

    > .nav-item {
      @extend %font-12;

      cursor: pointer;
      display: inline;
      transition: $trans-default;

      &:not(:first-of-type) {
        &::before {
          content: '';
          width: 1px;
          height: 10px;
          margin: 0 12px;
          background: #dadada;
          display: inline-block;
        }
      }

      @include vp-767 {
        display: block;
        padding-bottom: 16px;

        &:not(:first-of-type) {
          &::before {
            display: none;
          }
        }
      }
    }

    > .nav-item > .nav-link {
      transition: $trans-default;

      @include vp-767 {
        color: $color-potato-30;
        padding-bottom: 16px;
      }

      @include hover-focus {
        color: $color-kiwi-50;
      }
    }
  }
</style>
